import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect, Suspense, lazy } from "react";
import { checkUserFromStorage } from "./store/authSlice";
import Header from "./components/Header";
import { useTheme } from "./contexts/ThemeContext";

const Home = lazy(() => import("./pages/Home"));
const Favorites = lazy(() => import("./pages/Favorites"));
const Login = lazy(() => import("./pages/Login"));
const NotFound = lazy(() => import("./pages/NotFound"));
const SignUp = lazy(() => import("./pages/SignUp"));

function App() {
  const dispatch = useDispatch();
  const { isDarkMode } = useTheme();

  useEffect(() => {
    dispatch(checkUserFromStorage());
  }, [dispatch]);

  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [isDarkMode]);

  return (
    <Router>
      <Header />
      <Suspense
        fallback={
          <div style={{ marginTop: "64px", padding: "20px" }}>Loading...</div>
        }
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
